<template>
  <div class="model-btns__wrapper">
    <Score-b
      :value="seoData.rating"
      :review-count="seoData.review_count"
      itemprop
      :reviewComponent="reviewComponent"
      :hrefReviewComponent="hrefReviewComponent"
      @add-review="$emit('addReview')"
    />
    <div class="right-btns">
      <div class="right-btn favorite text-body-btns">
        <div class="icon">
          <ui-ui-button-ico
            icon="favorites"
            :response-size="[16, 16, 16, 20, 20, 20]"
            :responsiveIco="true"
            type="tertiary"
            :fill="favorite ? '#363EF8' : 'white'"
            stroke="#363EF8"
            @click="toggleFavorite"
          />
        </div>
        <div class="link">
          <ui-ui-link
            icon-before="favorites"
            size="medium"
            :class="['favorite', { 'favorite-active': favorite }]"
            :font-weight="400"
            :responsiveIco="true"
            :fill="favorite ? '#363EF8' : 'white'"
            @click="toggleFavorite"
          >
            {{ favorite ? 'В избранном' : 'В избранное' }}
          </ui-ui-link>
        </div>
      </div>
      <div class="right-btn compare text-body-btns">
        <div class="icon">
          <ui-ui-button-ico
            icon="compare"
            :responsiveIco="true"
            :response-size="[16, 16, 16, 20, 20, 20]"
            size="medium"
            type="tertiary"
            :fill="inCompare ? '#363EF8' : 'white'"
            stroke="#363EF8"
            @click="toggleCompare"
          />
        </div>
        <div class="link">
          <ui-ui-link
            icon-before="compare"
            size="medium"
            :class="['compare', { 'compare-active': inCompare }]"
            :responsiveIco="true"
            :font-weight="400"
            :fill="inCompare ? '#363EF8' : 'white'"
            @click="toggleCompare"
          >
            {{ inCompare ? 'В сравнении' : 'К сравнению' }}
          </ui-ui-link>
        </div>
      </div>

      <social-media-share
        v-if="!isSpeedBot"
        :title="seoData.title"
        :description="seoData.description"
        :image="seoData.image || null"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useFavoriteStore } from '~/stores/favorite';
import { useCompareStore } from '~/stores/compare';
import type { ModelItem } from '~/interfaces/api';

const { $ymAnyEvent } = useNuxtApp();
const props = defineProps({
  seoData: {
    type: Object as any,
    required: true,
  },
  pageData: {
    type: Object,
    required: true,
  },
  reviewComponent: {
    type: String,
    default: '',
  },
  hrefReviewComponent: {
    type: String,
    default: '',
  },
  isSpeedBot: {
    type: Boolean,
    default: false,
  },
});
defineEmits(['addReview']);
const favoriteStore = useFavoriteStore();
const compareStore = useCompareStore();

const favorite = computed(
  () =>
    props.pageData.model && favoriteStore.ids.includes(props.pageData.model.id)
);

const toggleFavorite = () => {
  if (props.pageData.model)
    favoriteStore.toggleFavorite({
      id: props.pageData.model.id,
      catId: props.pageData.model.category.id,
      deleteCard: favorite.value,
    });
};

const inCompare = computed(
  () =>
    props.pageData.model && compareStore.ids.includes(props.pageData.model.id)
);

const toggleCompare = () => {
  $ymAnyEvent('reachGoal', 'Compare');
  if (props.pageData.model) {
    compareStore.toggleCompare({
      id: props.pageData.model.id,
      catId: +(<ModelItem>props.pageData.model).category.id,
      deleteCard: inCompare.value,
    });
  }
};
</script>
<style scoped lang="scss" src="./ModelBtnsScss.scss"></style>
